const colors = {
    // Gray Scale
    gray: {
        50: "#F9FAFB",
        100: "#F3F4F6",
        200: "#E5E7EB",
        300: "#D1D5DB",
        400: "#9CA3AF",
        500: "#6B7280",
        600: "#4B5563",
        700: "#374151",
        800: "#1F2937",
        900: "#111827",
    },

    mint: {
        200: "#81b29a",
        500: "#92C3A5",
    },

    green: {
        100: "#3ECF8E", // Lightest - vibrant green
        200: "#34B277", // Light mint
        300: "#2A9561", // Medium mint
        400: "#204531", // Current primary
        500: "#1A3728", // Current dark
        600: "#152C20", // Darker forest
        700: "#102218", // Very dark forest
        800: "#0B1810", // Almost black green
        900: "#071008", // Nearly black
    },

    white: "#FFFFFF",
    black: "#000000",
    // appBg: "#121113",
    commonBg: "#1C1A1E",
    commonBgHover: "#262429",

    accordionBg: "#262429",

    border: "#1C1A1E",
    dialogBorder: "#262429",
    dialogBg: "#1C1A1E",
    // Additional colors
    red: {
        500: "#EF4444",
    },
    yellow: {
        500: "#F59E0B",
    },
    blue: {
        500: "#3B82F6",
    },
    gold: {
        500: "#F6C944",
    },
} as const;

export const COLORS = colors;
